
















import 'sanitize.css'
import '@icons/styles.css'
import './no_bounce'
import Setting from './components/Setting'
import Game from './components/Game'
import GithubIcon from '@icons/GithubCircle'

update_win_height = ->
  height = document.documentElement.clientHeight
  document.documentElement.style.setProperty '--win-height', "#{height}px"

export default
  name: 'app'
  data: ->
    mode: 'setting'
    in_touch: true
    prefs: {}
  methods:
    start: (prefs) ->
      @prefs = prefs
      @mode = 'game'
    back: ->
      @mode = 'setting'
  components: {
    Setting
    Game
    GithubIcon
  }
  mounted: ->
    if document.documentElement?.style?.setProperty?
      window.addEventListener 'resize', update_win_height, passive: true
      @$nextTick update_win_height
  beforeDestroy:
    window.removeEventListener 'resize', update_win_height
